var map = {
	"./cn.json": "f4a5",
	"./de.json": "6ce2",
	"./es.json": "a306",
	"./fr.json": "f693",
	"./gb.json": "974f",
	"./pt.json": "5d67",
	"./ro.json": "9542",
	"./sa.json": "7877",
	"./th.json": "8680",
	"./tr.json": "ffeb",
	"./us.json": "115b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "49f8";